/** Une réponse tardive reste rejouable avec le même identifiant, sans bloquer le brouillon. */
export function miniRequestWithTimeout<T>(
  request: Promise<T>,
  message: string,
  ms = 12000,
): Promise<T> {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => reject(new Error(message)), ms);
    request.then(
      (value) => {
        clearTimeout(timer);
        resolve(value);
      },
      (error) => {
        clearTimeout(timer);
        reject(error instanceof Error ? error : new Error(String(error)));
      },
    );
  });
}
